// extracted by mini-css-extract-plugin
export var logo = "_jo-2";
export var logoWrapper = "_jo-1";
export var strip = "_jo-0";